import script from "./OfferCards.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferCards.vue?vue&type=script&setup=true&lang=js"

import "./OfferCards.vue?vue&type=style&index=0&id=617054d2&lang=css"

const __exports__ = script;

export default __exports__